// eslint-disable-next-line import/no-cycle
import PaymentMethodCreditCard from '../components/checkout-steps/payment/payment-method-credit-card';
import PaymentMethodKWallet from '../components/checkout-steps/payment/payment-method-k-wallet';
import PaymentMethodRedsys from '../components/checkout-steps/payment/payment-method-redsys';
import PaymentMethodTropipay from '../components/checkout-steps/payment/payment-method-tropipay';

export const AVAILABLES_FOR = {
    billing: 'available_for_billing_true',
    shipping: 'available_for_shipping_true',
};

export const PAYMENT_METHODS = {
    credit_card: 'Credit Card',
    redsys_redirect: 'Redsys',
    tropipay: 'Tropipay',
};

export const PAYMENT_METHOD_COMPONENT_MAPPING = () => {
    const mapping = {};
    mapping['Spree::Gateway::PinserveGateway'] = PaymentMethodCreditCard;
    mapping['Spree::Gateway::ElavonGateway'] = PaymentMethodCreditCard;
    mapping['Spree::BillingIntegration::RedsysPayment'] = PaymentMethodRedsys;
    mapping['Spree::BillingIntegration::TropiPayPayment'] = PaymentMethodTropipay;
    if (process.env.REACT_APP_KWALLET_ENABLED === 'true') {
        mapping['Spree::Gateway::KwalletGateway'] = PaymentMethodKWallet;
    }

    return mapping;
};



/** WEBPACK FOOTER **
 ** ./src/constants/app-chekout.js
 **/